import { render } from "./MessagePrompt.vue?vue&type=template&id=99a079c6&scoped=true"
import script from "./MessagePrompt.vue?vue&type=script&lang=js"
export * from "./MessagePrompt.vue?vue&type=script&lang=js"

import "./MessagePrompt.vue?vue&type=style&index=0&id=99a079c6&lang=scss&scoped=true"

import exportComponent from "/Users/jason.pollock/Containers/globaltech/packages/fool-wp-commerce/vue-commerce/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99a079c6"]])

export default __exports__